import PropTypes from "prop-types"
import React, { useMemo, useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  UncontrolledTooltip
} from "reactstrap"
import { Link } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import TableContainer from "../../components/Common/TableContainer"
import swal from "sweetalert"

const inithotels = [
    {
        id: 1,
        nom: "MR ABC",
        surnom: "ABC",
        airline: "Air Algerie",
        numPassport: "123456789",
        de: "Service A, Service B",
        nationality: "Nationality A",
        phone: "+1234567890",
       
      },
      {
        id: 2,
        nom: "MR XYZ",
        surnom: "XYZ",
        airline: "Air Algerie",
        numPassport: "987654321",
        de: "Service C, Service D",
        nationality: "Nationality B",
        phone: "+9876543210",
        
      },
      {
        id: 3,
        nom: "MR ABC",
        surnom: "ABC",
        airline: "Air Algerie",
        numPassport: "123456789",
        de: "Service A, Service B",
        nationality: "Nationality A",
        phone: "+1234567890",
       
      },
      {
        id: 4,
        nom: "MR XYZ",
        surnom: "XYZ",
        airline: "Air Algerie",
        numPassport: "987654321",
        de: "Service C, Service D",
        nationality: "Nationality B",
        phone: "+9876543210",
        
      },
      {
        id: 5,
        nom: "MR ABC",
        surnom: "ABC",
        airline: "Air Algerie",
        numPassport: "123456789",
        de: "Service A, Service B",
        nationality: "Nationality A",
        phone: "+1234567890",
       
      },
      {
        id: 6,
        nom: "MR XYZ",
        surnom: "XYZ",
        airline: "Air Algerie",
        numPassport: "987654321",
        de: "Service C, Service D",
        nationality: "Nationality B",
        phone: "+9876543210",
        
      },
      {
        id: 7,
        nom: "MR ABC",
        surnom: "ABC",
        airline: "Air Algerie",
        numPassport: "123456789",
        de: "Service A, Service B",
        nationality: "Nationality A",
        phone: "+1234567890",
       
      },
      {
        id: 8,
        nom: "MR XYZ",
        surnom: "XYZ",
        airline: "Air Algerie",
        numPassport: "987654321",
        de: "Service C, Service D",
        nationality: "Nationality B",
        phone: "+9876543210",
        
      },
]

const BilletAvion = (props) => {
  const [selectedRows, setSelectedRows] = useState([])
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false)
  const [hotels, setHotels] = useState(inithotels)
  // Function to handle select all checkboxes
  const handleSelectAll = () => {
    if (isSelectAllChecked) {
      setSelectedRows([])
    } else {
      setSelectedRows(hotels.map((hotel) => hotel.id))
    }
    setIsSelectAllChecked(!isSelectAllChecked)
  }

  // Function to handle individual row selection
  const handleRowSelect = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id))
    } else {
      setSelectedRows([...selectedRows, id])
    }
  }

  // Function to handle hotel deletion
  const handleDelete = (hotelData) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this billet!",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const updatedHotels = hotels.filter((hotel) => hotel.id !== hotelData.id)
        setHotels(updatedHotels)
        setSelectedRows(selectedRows.filter((rowId) => rowId !== hotelData.id))
        swal("The billet has been deleted!", {
          icon: "success",
        })
      } else {
        swal("Deletion canceled")
      }
    })
  }

  
  const handleCheck = (hotelData) => {
    window.location.href = `/billet-checkout/${hotelData.id}`
  }

  const handleEdit = (hotelData) => {
    swal({
      title: "Edit Billet",
      content: {
        element: "div",
        attributes: {
          innerHTML: `
            <div>
              <label for="nom">Nom:</label>
              <input type="text" id="nom" value="${hotelData.nom}" class="swal-content__input" />
              <label for="surnom">Surnom:</label>
              <input type="text" id="surnom" value="${hotelData.surnom}" class="swal-content__input" />
              <label for="airline">Airline:</label>
              <input type="text" id="airline" value="${hotelData.airline}" class="swal-content__input" />
              <label for="numPassport">No. Passport:</label>
              <input type="text" id="numPassport" value="${hotelData.numPassport}" class="swal-content__input" />
              <label for="de">DE:</label>
              <input type="text" id="de" value="${hotelData.de}" class="swal-content__input" />
              <label for="nationality">Nationality:</label>
              <input type="text" id="nationality" value="${hotelData.nationality}" class="swal-content__input" />
              <label for="phone">Phone:</label>
              <input type="text" id="phone" value="${hotelData.phone}" class="swal-content__input" />
            </div>
          `,
        },
      },
      buttons: ["Cancel", "Save"],
    }).then((willSave) => {
      if (willSave) {
        const nom = document.getElementById("nom").value
        const surnom = document.getElementById("surnom").value
        const airline = document.getElementById("airline").value
        const numPassport = document.getElementById("numPassport").value
        const de = document.getElementById("de").value
        const nationality = document.getElementById("nationality").value
        const phone = document.getElementById("phone").value

        const updatedHotel = {
          ...hotelData,
          nom: nom,
          surnom: surnom,
          airline: airline,
          numPassport: numPassport,
          de: de,
          nationality: nationality,
          phone: phone,
        }

        const updatedHotels = hotels.map((hotel) =>
          hotel.id === hotelData.id ? updatedHotel : hotel
        )

        setHotels(updatedHotels)
        swal("The billet has been updated!", {
          icon: "success",
        })
      }
    })
  }

  const columns = useMemo(
    () => [
      {
        header: () => (
          <FormGroup check className="font-size-16">
            <Label check>
              <Input
                type="checkbox"
                id="checkAll"
                checked={isSelectAllChecked}
                onChange={handleSelectAll}
              />
            </Label>
          </FormGroup>
        ),
        accessorKey: "id",
        cell: (cellProps) => (
          <FormGroup check className="font-size-16">
            <Label check>
              <Input
                type="checkbox"
                checked={selectedRows.includes(cellProps.row.original.id)}
                onChange={() => handleRowSelect(cellProps.row.original.id)}
              />
            </Label>
          </FormGroup>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Nom",
        accessorKey: "nom",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Surnom",
        accessorKey: "surnom",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Airline",
        accessorKey: "airline",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "No. Passport",
        accessorKey: "numPassport",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "DE",
        accessorKey: "de",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Nationality",
        accessorKey: "nationality",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Phone",
        accessorKey: "phone",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => (
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-primary"
              id={`checktooltip-${cellProps.row.original.id}`}
              onClick={() => handleCheck(cellProps.row.original)}
            >
              <i className="mdi mdi-check-circle font-size-18" />
              <UncontrolledTooltip placement="top" target={`checktooltip-${cellProps.row.original.id}`}>
                Check
              </UncontrolledTooltip>
            </Link>
            <Link
              to="#"
              className="text-danger"
              onClick={() => handleDelete(cellProps.row.original)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    [selectedRows, isSelectAllChecked]
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Billet D'avion")}
            breadcrumbItem={props.t("Billet D'avion")}
          />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle style={{ marginBottom: "40px" }}>
                    {props.t("Billet D'avion Reservation")}
                  </CardTitle>

                  <TableContainer
                    columns={columns}
                    data={hotels}
                    isGlobalFilter={true}
                    isAddButton={false}
                    isPagination={true}
                    SearchPlaceholder="Cherchez un Billet"
                    buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
                    buttonName="Ajoute un billet"
                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                    theadClass="table-light"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

BilletAvion.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withTranslation()(BilletAvion)